import * as React from 'react';
import CardsManager from '../CardsManager/CardsManager';
import FindBook from '../Header/FindBook/FindBook';
import { useMediaQuery } from 'react-responsive';
import { MOBILE_MAX_WIDTH } from '../../utils';
import AddBookFloat from '../AddBookFloat/AddBookFloat';

const SearchModule: React.FC = props => {
	const isMobile = useMediaQuery({ maxWidth: MOBILE_MAX_WIDTH });

	return <CardsManager withoutInitial={true}>
		{
			(callbacks) => {
				return isMobile ? <AddBookFloat callbacks={callbacks}/> : <FindBook callbacks={callbacks} withoutInitial={true} />;
			}
		}
	</CardsManager>;
};

export default SearchModule;
